import { z } from 'zod';
export var FlowLookbackDurationUnit;
(function (FlowLookbackDurationUnit) {
    FlowLookbackDurationUnit["Days"] = "days";
    FlowLookbackDurationUnit["Weeks"] = "weeks";
    FlowLookbackDurationUnit["Months"] = "months";
    FlowLookbackDurationUnit["Years"] = "years";
})(FlowLookbackDurationUnit || (FlowLookbackDurationUnit = {}));
export const FlowLookbackDurationSchema = z.object({
    value: z.coerce.number().min(0, { message: 'Duration value cannot be negative' }),
    unit: z.enum(FlowLookbackDurationUnit, { message: 'Unit is required' }),
});
export var FlowDurationUnits;
(function (FlowDurationUnits) {
    FlowDurationUnits["Years"] = "years";
    FlowDurationUnits["Weeks"] = "weeks";
    FlowDurationUnits["Days"] = "days";
    FlowDurationUnits["Hours"] = "hours";
    FlowDurationUnits["Minutes"] = "minutes";
    FlowDurationUnits["Seconds"] = "seconds";
})(FlowDurationUnits || (FlowDurationUnits = {}));
export const FlowDurationSchema = z.object({
    value: z.number().min(0),
    units: z.enum(FlowDurationUnits),
});
//# sourceMappingURL=duration.js.map